'use client';

import dynamic from 'next/dynamic';
import type { FC, JSX } from 'react';
import type { TravelInformationAccordionData } from '@/components/travelInformation/TravelInformationAccordion';

const TravelInformationAccordion = dynamic(
  () => import('@/components/travelInformation/TravelInformationAccordion')
);

const TravelInformationAccordionClientImporter: FC<{
  groups: Array<Partial<TravelInformationAccordionData>>;
  showGeneralForHold?: boolean;
}> = (props): JSX.Element => {
  return <TravelInformationAccordion {...props} />;
};

export default TravelInformationAccordionClientImporter;
